import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { LoadingPanelService } from "../../shared/loading-panel/loading-panel.service";
import { ArtifactAssemblyTypes, AssemblyArtifact } from "../models/artifact";
import { DeveloperService } from "../services/developer.service";
import { CurrentUserService } from "../../user/services";
import { DeveloperArtifactService } from "../services/developer-artifact.service";
import { DocumentTypeClassifierResolverEntity } from "../models/document-type-classifier-resolver";
import { ContentTypeService } from "../../distribution/services/distribution-content-type.service";
import { ContentTypeGroup } from "../../distribution/models/content-type-group";
import { ToastService, ToastType } from "../../shared/toast/toast.service";
import { SvgIconComponent } from "../../shared/icons/svg-icon.component";
import { PermissionRequiredDirective } from "../../shared/authentication/permission-required.directive";
import { ChangeLogLinkComponent } from "../../shared/change-log/change-log-link/change-log-link.component";
import { ChangeLogLinkEntityDirective } from "../../shared/change-log/change-log-link-entity/change-log-link-entity.directive";
import { DxDataGridModule } from "devextreme-angular";
import { BizDataGridDirective } from "../../shared/grid/biz-grid.directive";
import { DxoEditingModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxiButtonModule } from "devextreme-angular/ui/nested";
import { DxTemplateModule } from "devextreme-angular/core";
import { FormsModule } from "@angular/forms";

import { DeveloperArtifactAssemblyPickerComponent } from "../developer-artifacts/developer-artifact-assembly-picker.component";
import { BizGridFiltervalues } from 'src/app/shared/grid/biz-grid-filtervalues';
import { BizDateColumnDirective } from 'src/app/shared/grid/biz-grid-date.directive';
import { BizUserColumnDirective } from 'src/app/shared/grid/biz-grid-user.directive';
import { GridService } from "../../shared/grid/grid.service";
import { DxDataGridTypes } from "devextreme-angular/ui/data-grid";

@Component({
    selector: 'app-developer-document-type-classifier-resolver',
    templateUrl: './developer-document-type-classifier-resolver.component.html',
    styleUrls: ['./developer-document-type-classifier-resolver.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxiButtonModule, DxTemplateModule, FormsModule, DeveloperArtifactAssemblyPickerComponent, BizUserColumnDirective, BizDateColumnDirective]
})
export class DeveloperDocumentTypeClassifierResolversComponent implements OnInit {

    hasCreatePerm = false;
    hasEditPerm = false;
    hasDeletePerm = false;
    hasShowLogPerm = false;

    selectedContentTypeGroup: number | null = null;

    artifacts: AssemblyArtifact[] = [];
    contentTypeGroups: ContentTypeGroup[] = [];
    documentTypeClassifierResolver: DocumentTypeClassifierResolverEntity[] = [];

    constructor(
        private loadingPanelService: LoadingPanelService,
        private toastService: ToastService,
        private currentUserService: CurrentUserService,
        private developerArtifactService: DeveloperArtifactService,
        private contentTypeService: ContentTypeService,
        private developerService: DeveloperService,
        private gridService: GridService,
        public bizGridFiltervalues: BizGridFiltervalues) {
            this.displayExprArtifact = this.displayExprArtifact.bind(this);
    }

    async ngOnInit() {
        this.loadingPanelService.showLoadingPanelDirect('Loading document type classifer resolvers...');
        this.hasCreatePerm = this.currentUserService.hasPermission('Developer_Action_DocumentTypeClassifierResolver_Create');
        this.hasEditPerm = this.currentUserService.hasPermission('Developer_Action_DocumentTypeClassifierResolver_Edit');
        this.hasDeletePerm = this.currentUserService.hasPermission('Developer_Action_DocumentTypeClassifierResolver_Delete');
        this.hasShowLogPerm = this.currentUserService.hasPermission('Developer_Action_ShowLog');
        this.artifacts = await this.developerArtifactService.getAssemblyArtifacts(true, [ArtifactAssemblyTypes.TypeDocumentTypeClassiferResolver, ArtifactAssemblyTypes.TypeDocumentTypeClassiferResolver2]);
        this.contentTypeGroups = (await this.contentTypeService.getContentTypeGroups()).sort((a, b) => a.Name.localeCompare(b.Name));
        this.loadingPanelService.hideLoadingPanel();
        this.refresh();
    }

    async refresh() {
        this.loadingPanelService.showLoadingPanelDirect('Loading document type classifer resolvers...');
        this.documentTypeClassifierResolver = await this.developerService.getDocumentTypeClassifierResolvers();
        this.loadingPanelService.hideLoadingPanel();
    }

    displayExprArtifact(e: any) {
        // TODO: Find en bedre måde at håndtere dette, så det ikke er nødvendigt at loade alle artifacts...
        if (this.artifacts) {
            var artifact = this.artifacts.find(a => a.ArtifactId == e.value);
            if (artifact) {
                return `${artifact.Name} [${artifact.ClassName}] [${artifact.Filename}]`;
            }
        }
        return "Unknown...";
    }

    async onArtifactChanged(artifactId: string, cellInfo: any) {
        cellInfo.setValue(artifactId);
    }

    onGenericIdChanged(id: number, cellInfo: any) {
        cellInfo.setValue(id);
    }

    getContentTypeGroupName(documentTypeClassifierResolverEntity: DocumentTypeClassifierResolverEntity): string {
        return this.contentTypeGroups.filter(x=>x.Id == documentTypeClassifierResolverEntity.ContentTypeGroupId)[0]?.Name
    }

    getContentTypeName(contentTypeGroup: ContentTypeGroup): string {
        let contentTypeNames = '';
        contentTypeGroup.ContentTypes.forEach(ct => {
            contentTypeNames = contentTypeNames.concat(ct.Name + '\r\n');
        });
        return contentTypeNames;
    }

    async onEditingStart(e: any) {
        const documentTypeClassifierResolverEntity = e.data as DocumentTypeClassifierResolverEntity;
        this.selectedContentTypeGroup = documentTypeClassifierResolverEntity.ContentTypeGroupId;
    }

    onCellPrepared(e) {
        if (e.rowType === 'data') {
            if (e.column.dataField === 'ContentTypeGroupId') {
                e.cellElement.mouseover(() => {
                    const contentTypeGroupId = e.row.cells[e.columnIndex].data.ContentTypeGroupId;
                    const contentTypeGroup = this.contentTypeGroups.filter(x=>x.Id == contentTypeGroupId)[0]
                    if (contentTypeGroup) {
                        let contentTypeNames = '';
                        contentTypeGroup.ContentTypes.forEach(ct => {
                            contentTypeNames = contentTypeNames.concat(ct.Name + '\r\n');
                        });
                        e.cellElement.attr('title', contentTypeNames);
                    }
                });
            }
            if (e.column.dataField === 'category.Name') {
                const category = e.row.cells[e.columnIndex].data.category;
                e.cellElement.attr('title', category.Description);
            }
        }
    }

    onInitNewRow(e: DxDataGridTypes.InitNewRowEvent<DocumentTypeClassifierResolverEntity>): void {
        this.selectedContentTypeGroup = null;
        e.data = { Id: null, Name: '', ContentTypeGroupId: null, ArtifactId: null } as DocumentTypeClassifierResolverEntity;
    }

    onRowInserting = (e: DxDataGridTypes.RowInsertingEvent<DocumentTypeClassifierResolverEntity>): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data, item => this.saveDocumentTypeClassifierResolver(item));
    };

    onRowUpdating = (e: DxDataGridTypes.RowUpdatingEvent<DocumentTypeClassifierResolverEntity>): void => {
        e.cancel = this.gridService.handleDataGridRow({ ...e.oldData, ...e.newData }, item => this.saveDocumentTypeClassifierResolver(item), e.newData);
    };

    onRowRemoving = (e: DxDataGridTypes.RowRemovingEvent<DocumentTypeClassifierResolverEntity>): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data, item => this.removeDocumentTypeClassifierResolver(item));
    };

    async saveDocumentTypeClassifierResolver(item: DocumentTypeClassifierResolverEntity): Promise<DocumentTypeClassifierResolverEntity> {
        try {
            const savedItem = await this.developerService.saveDocumentTypeClassifierResolver(item);
            this.toastService.showToast('Document type classifier resolver saved...', ToastType.success);
            return savedItem;
        }
        catch (err) {
            console.error(err);
            this.toastService.showToast('Failed to save document type resolver classifier...', ToastType.error);
            return undefined;
        }
    }

    async removeDocumentTypeClassifierResolver(item: DocumentTypeClassifierResolverEntity): Promise<DocumentTypeClassifierResolverEntity> {
        await this.developerService.deleteDocumentTypeClassifierResolver(item.Id);
        this.toastService.showToast('Document type classifier resolver deleted...', ToastType.success);
        return item;
    }
}
